import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupOutrightsOddsByName',
})
export class GroupOutrightOddsByName implements PipeTransform {
  transform(value): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          //var groupName = o.OddType;
          const groupName = o.OddsType;
          //var seqNum = o.SeqNumber;
          groups[groupName] = groups[groupName] ? groups[groupName] : { GroupName: groupName, eOdds: [] };
          groups[groupName].eOdds.push(o);
        });
      }
    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
